const containerVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { delay: 0.2, duration: 0.3 },
  },
  exit: {
    transition: { ease: "easeInOut" },
  },
};

export default containerVariants;
